// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loading_loadingWrapper__aN8a+"};